import * as tslib_1 from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import HeaderCharm from './HeaderCharm';
import strings from 'owa-strings/owa-common-strings';
import { SettingsPane } from 'owa-header-pane';
import { observer } from 'mobx-react';
import { SettingIconFirstRunCallout } from 'owa-header-fre';
import { eventMgr, SettingPanelFirstRunCalloutDismissedEvent, LightningId } from 'owa-lightning-v2';
import { WebPushDiscovery } from 'owa-webpush-notifications';
var SettingsCharm = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsCharm, _super);
    function SettingsCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsCharm.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(HeaderCharm, { ref: function (ref) { return (_this.target = ReactDOM.findDOMNode(ref)); }, key: "settings", icons: { iconName: "Settings" /* Settings */ }, title: strings.settingsCharm_ariaLabel, ariaLabel: strings.settingsCharm_ariaLabel, behavior: {
                    paneComponent: SettingsPane,
                    charm: 4 /* SettingsCharm */,
                } }),
            React.createElement(SettingIconFirstRunCallout, { lid: LightningId.SettingIconFirstRunCallout, when: this.activateSettingsCharmCallout, series: [
                    LightningId.AnimatedConsumerRefreshFRE2,
                    LightningId.SettingPanelFirstRunCallout,
                    LightningId.SettingIconFirstRunCallout,
                ], target: function () { return _this.target; } }),
            React.createElement(WebPushDiscovery, { calloutTarget: function () { return _this.target; } })));
    };
    SettingsCharm.prototype.activateSettingsCharmCallout = function (lightup) {
        eventMgr.on(SettingPanelFirstRunCalloutDismissedEvent, function () {
            return setTimeout(function () { return lightup(); }, 500);
        });
    };
    SettingsCharm = tslib_1.__decorate([
        observer
    ], SettingsCharm);
    return SettingsCharm;
}(React.Component));
export default SettingsCharm;
//# sourceMappingURL=SettingsCharm.js.map